type Props = {
  fill?: string;
  height?: number;
  width?: number;
};

// Same pin and white disc as UntrackedPin, with an "excluded document" glyph (page struck through) instead of the bolt.
const NotInReportPin = ({ fill = '#808080', height = 40, width = 40 }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="NotInReportPin">
      <path
        d="M19.9634 3.33301C13.52 3.33301 8.33331 8.55634 8.33331 14.9997C8.33331 23.333 19.9634 36.6663 19.9634 36.6663C19.9634 36.6663 31.6666 23.333 31.6666 14.9997C31.6666 8.55634 26.4067 3.33301 19.9634 3.33301Z"
        fill={fill}
      />
      <circle cx="20" cy="15" r="8.333" fill="white" />
      {/* Page with a folded top-right corner */}
      <path d="M17 10H21L24 13V19C24 19.5523 23.5523 20 23 20H17C16.4477 20 16 19.5523 16 19V11C16 10.4477 16.4477 10 17 10Z" fill={fill} />
      <path d="M21 10V13H24" stroke="white" strokeWidth="1.25" strokeLinejoin="round" />
      {/* Strike-through, separated from the page by a white gap so it stays readable at legend size */}
      <path d="M16 11L24 19" stroke="white" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M15 10L25 20" stroke={fill} strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
};

export default NotInReportPin;
